module.exports = __webpack_public_path__ + "img/logo-large.3d28405e.png";